export default "__VITE_ASSET__CcQcsOvF__"